export default Object.freeze([
    'highCationic',
    'lowCationic',
    'highAnionic',
    'lowAnionic',
]);
